module.exports = __webpack_public_path__ + "img/tax-assist.ec3aadb3.svg";